import { createContext, use } from 'react';

/**
 * The shell owns a slot in its sticky header bar; each page renders its breadcrumb into it (React portal),
 * so the page keeps the context of its title while the header stays part of the shell.
 * @type {import('react').Context<HTMLElement | null>}
 */
export const HeaderSlotContext = createContext(/** @type {HTMLElement | null} */ (null));

export function useHeaderSlot() {
  return use(HeaderSlotContext);
}
